var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-copy-promotion"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("既存のプログラム情報一覧")])])],1),_c('el-row',[_c('el-col',[_c('CopyPromotionList',{attrs:{"toolId":_vm.toolId,"accountId":_vm.accountId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }